import {css} from "@emotion/react";

export const topRow = css`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 0.5px;
    background-color: #C5CACE;
`;